import React from "react";
import { Box, Divider, Paper, Stack, Typography } from "@mui/material";

// Sección de un editor de automatización («Cuando», «Salida», «Seguridad»…), con icono, subtítulo y acciones.
const SectionCard = ({ title, subtitle, icon, accent = "primary.main", headerActions = null, children }) => (
    <Paper
        variant="outlined"
        sx={{
            p: { xs: 1.75, md: 2 },
            borderRadius: 3,
            borderColor: "rgba(15, 23, 42, 0.08)",
            background: "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.86))",
            boxShadow: "0 16px 44px rgba(15, 23, 42, 0.05)",
        }}>
        <Stack spacing={1.5}>
            <Stack
                direction={{ xs: "column", lg: "row" }}
                alignItems={{ xs: "flex-start", lg: "center" }}
                justifyContent="space-between"
                spacing={1.5}>
                <Stack direction="row" spacing={1.25} alignItems="center">
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: 2.5,
                            display: "grid",
                            placeItems: "center",
                            color: accent,
                            bgcolor: "rgba(103, 58, 183, 0.08)",
                            flex: "0 0 auto",
                            "& .MuiSvgIcon-root": {
                                fontSize: 28,
                            },
                        }}>
                        {icon}
                    </Box>
                    <Stack spacing={0}>
                        <Typography variant="h5" sx={{ fontSize: "1.1rem", fontWeight: 500 }}>{title}</Typography>
                        {!!subtitle && (
                            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2, m: 0 }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
                {!!headerActions && (
                    <Box sx={{ width: { xs: "100%", lg: "auto" }, ml: { lg: 2 } }}>
                        {headerActions}
                    </Box>
                )}
            </Stack>

            <Divider />
            {/* Caja propia y no hijos directos del Stack: el Stack anula el margen negativo de las grillas (Grid
                container) y los campos quedaban corridos a la derecha. */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {children}
            </Box>
        </Stack>
    </Paper>
);

export default SectionCard;
